/*
 * @Author: liu.huirong
 * @Date: 2021-11-25 10:01:50
 * @Last Modified by: zhang.si
 * @Last Modified time: 2022-08-03 10:53:01
 * @Des: 头部标题组件
 * @param title 展示标题
 * @param hideGoHome 隐藏回商城首页的icon
 * @param hideGoBack 隐藏返回上一页的icon
 */
import React from 'react';
import { connect, history } from 'umi';

// import { isEmpty, get, head } from 'lodash';
import useGCPI18n from '@/hooks/useGCPI18n';
import { onHistoryPush } from '@/utils/utils';
import { trackSensors } from '@/utils/sensors';
import { Clickable } from '@/components';
import backIcon from '@/assets/images/back.png';
import styles from './index.less';

const Header = props => {
  const {
    title,
    goBack: propsGoback,
    hideGoBack = false,
    isWheel = false, // 是否是大转盘
  } = props;
  const GCPI18n = useGCPI18n();

  const handleGoBack = () => {
    if (typeof propsGoback === 'function') {
      propsGoback();
    } else {
      history.goBack();
    }
  };

  const handleRules = () => {
    // 神策埋点
    trackSensors('SpintoWinClick', {
      button_name: 'Mechanics',
    });
    onHistoryPush('/rules');
  };

  return (
    <header className={styles.header}>
      <Clickable
        className={`${styles.imgBox} ${hideGoBack ? styles.hideGoBack : ''}`}
        onClick={handleGoBack}
      >
        <img alt="" src={backIcon} />
        <h3 title={title}>{title}</h3>
      </Clickable>
      {isWheel && (
        <Clickable className={styles.mechanics} onClick={handleRules}>
          {GCPI18n({ id: 'lb_main_mechanics' })}
        </Clickable>
      )}
    </header>
  );
};

const mapDispatchToProps = dispatch => ({
  batchCreateUtmLink: payload =>
    dispatch({
      type: 'index/batchCreateUtmLink',
      payload,
    }),
});
export default connect(
  ({ index }) => ({
    activityDetail: index.activityDetail,
  }),
  mapDispatchToProps,
)(Header);
